/* NEXby footer: link columns are open on wide screens, collapsed accordions on mobile (native <details>). */
(function () {
  var mq = window.matchMedia('(min-width: 750px)');
  var items = document.querySelectorAll('[data-nexby-footer-acc]');
  if (!items.length) return;
  function sync() {
    items.forEach(function (d) {
      d.open = mq.matches;
    });
  }
  sync();
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else mq.addListener(sync);
  /* On wide screens the headings are not toggles. */
  items.forEach(function (d) {
    d.querySelector('summary').addEventListener('click', function (e) {
      if (mq.matches) e.preventDefault();
    });
  });
})();
